import React from 'react';
import './LinkList.css';

const LinkList = ({ links, loading, onDelete, getShortUrl }) => {
  const handleCopy = (shortCode) => {
    const shortUrl = getShortUrl(shortCode);
    navigator.clipboard.writeText(shortUrl);
    alert('Link copiado para a área de transferência!');
  };

  if (loading) {
    return <div className="loading">Carregando links...</div>;
  }

  if (links.length === 0) {
    return (
      <div className="empty-state">
        <p>Nenhum link criado ainda. Crie seu primeiro link acima!</p>
      </div>
    );
  }

  return (
    <div className="link-list">
      <h2>Meus Links</h2>
      <div className="links-grid">
        {links.map((link) => (
          <div key={link.id} className="link-card">
            <div className="link-header">
              <div className="link-header-block">
                <div className="link-info-line">
                  <span className="link-label">Apelido:</span>
                  <span className="link-value">{link.alias?.trim() ? link.alias : '—'}</span>
                </div>
                {link.is_whatsapp ? (
                  <>
                    <div className="link-info-line">
                      <span className="link-label">Destino:</span>
                      <span className="link-value">WhatsApp</span>
                    </div>
                    <div className="link-info-line">
                      <span className="link-label">Telefone:</span>
                      <span className="link-value">{link.whatsapp_phone}</span>
                    </div>
                    <div className="link-info-line">
                      <span className="link-label">Mensagem:</span>
                      <span className="link-value">
                        {link.whatsapp_message?.length > 60
                          ? `${link.whatsapp_message.substring(0, 60)}...`
                          : link.whatsapp_message}
                      </span>
                    </div>
                  </>
                ) : (
                  <div className="link-info-line">
                    <span className="link-label">URL Original:</span>
                    <span className="link-value">
                      {link.original_url.length > 60
                        ? `${link.original_url.substring(0, 60)}...`
                        : link.original_url}
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div className="link-body">
              <div className="short-url">
                <label>Link Encurtado:</label>
                <div className="url-display">
                  <code>{getShortUrl(link.short_code)}</code>
                  <button
                    onClick={() => handleCopy(link.short_code)}
                    className="copy-btn"
                    title="Copiar"
                  >
                    📋
                  </button>
                </div>
              </div>
              <div className="link-stats-mini">
                <span>📊 {link.total_accesses || 0} acessos</span>
              </div>
            </div>
            <div className="link-actions">
              <button
                onClick={() => window.open(`/stats/${link.id}`, '_blank')}
                className="stats-btn"
              >
                📈 Ver Estatísticas
              </button>
              <button
                onClick={() => {
                  if (window.confirm('Tem certeza que deseja deletar este link?')) {
                    onDelete(link.id);
                  }
                }}
                className="delete-btn"
              >
                🗑️ Deletar
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LinkList;

